/**
 * 全ページに読み込ませる未ログインユーザーの共通処理はここに記述
 * views/layouts/application.htmlでロードしている
 */

import NeedSignupPromptModal from 'modules/NeedSignupPromptModal';
import GlobalDrawerMenu from 'modules/GlobalDrawerMenu';

new NeedSignupPromptModal();

// SP版メニュー
new GlobalDrawerMenu();
